export default {
  states: [],
  cities: []
}
